import React from "react";
import { Result, Button } from "antd";
import { useNavigate } from "react-router-dom";

const PaymentCancelService = () => {
  const navigate = useNavigate();

  return (
    <Result
      status="warning"
      title="Payment Cancelled"
      subTitle="Your payment was not completed. No charges were made."
      extra={[
        <Button
          type="primary"
          key="retry"
          onClick={() => navigate(-1)}
        >
          Try Again
        </Button>,
        <Button
          key="courses"
          onClick={() => navigate("/selfLearner-dashboard")}
        >
          Go to My Dashboard
        </Button>,
      ]}
    />
  );
};

export default PaymentCancelService;
